module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-3.33537c101cc96d138e866af589b44c86.jpg";